var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVrc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#418BCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3991 4.5H14.0625L9 14.625L3.9375 4.5H6.5835L9.01744 9.62606L11.3991 4.5ZM9 7.28944C8.55675 7.28944 8.19731 6.92044 8.19731 6.46538C8.19731 6.01031 8.55675 5.64075 9 5.64075C9.44325 5.64075 9.80269 6.01031 9.80269 6.46538C9.80269 6.92044 9.44269 7.28944 9 7.28944ZM12.6366 9.56194C13.0798 9.56194 13.4392 9.9315 13.4387 10.3866C13.4387 10.8422 13.0798 11.2106 12.6366 11.2106C12.1933 11.2106 11.8339 10.8416 11.8339 10.3866C11.8339 9.9315 12.1933 9.56194 12.6366 9.56194Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrc);
export default __webpack_public_path__ + "static/media/vrc.bee4e9b6b0693b72d21123fcf8758ffa.svg";
export { ForwardRef as ReactComponent };